import type { GBPACreateReportSettings } from './schema';
import { GBPACreateReportResponseSchema, GBPARunReportResponseSchema } from './schema';
import { HTTP_METHOD } from '../../../consts';
import type { ApiCallOptions, Transport } from '../../../types';

export const createGBPAReportApi = (transport: Transport) => ({
  createReport: (settings: GBPACreateReportSettings, options?: ApiCallOptions) =>
    transport('/seo-tools/api/v4/gpw/add', {
      method: HTTP_METHOD.POST,
      body: {
        ...settings,
        search_terms: JSON.stringify(settings.search_terms)
      },
      deserializer: GBPACreateReportResponseSchema,
      signal: options?.signal
    }),
  runReport: (reportId: number, options?: ApiCallOptions) =>
    transport('/seo-tools/api/v4/gpw/run', {
      method: HTTP_METHOD.POST,
      body: { 'report-id': reportId },
      deserializer: GBPARunReportResponseSchema,
      signal: options?.signal
    })
});

export type GBPAReportApi = ReturnType<typeof createGBPAReportApi>;
